module.exports = __webpack_public_path__ + "img/participa.70ec6b1d.png";